<template>
    <div></div>
</template>

<script>
import echarts from 'echarts'

export default {
    
}
</script>

<style>

</style>